import { ReportEmergencyCallButton } from '../ReportEmergencyCallButton'
import type { ScreenInteractionContext } from '../platform/analytics/interactionAnalytics'

type Props = {
  phone: string
  /** Shown beside the dial button to clarify intent. */
  label?: string
  variant?: 'compact' | 'standard'
  analytics?: ScreenInteractionContext
}

export function EmergencyDialAction({
  phone,
  label = 'Report an Emergency',
  variant = 'compact',
  analytics,
}: Props) {
  return (
    <div className={`emergency-dial-action emergency-dial-action--${variant}`}>
      <span className="emergency-dial-action-label">{label}:</span>
      <ReportEmergencyCallButton phone={phone} variant={variant} analytics={analytics} />
    </div>
  )
}
